import { useTranslation } from 'react-i18next';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { CONTENT_ALIGNMENT } from '@pperform/pp-constants/widgetConfigs';
import { useDetectDevice } from 'hooks';
import Shipment from 'interfaces/PmParcel';
import {
  ShipmentDisplay,
  getShipmentDisplayFactory,
} from 'utils/shipmentDisplay.utils';
import { Container } from './TrackingDetailsHeader.styles';

interface TrackingDetailsHeaderProps {
  shipment?: Shipment;
  hasMultipleShipments?: boolean;
}
export const TrackingDetailsHeader = ({
  shipment,
  hasMultipleShipments = false,
}: TrackingDetailsHeaderProps) => {
  const { t } = useTranslation();
  const { isMobile } = useDetectDevice();
  const configs = usePTPConfigContext();
  const {
    trackingDetailsBox: { headerAlignment },
  } = configs;

  const getTitle = () => {
    if (!shipment) return '';

    const shipmentDisplayFactory = getShipmentDisplayFactory(
      configs,
      shipment,
      t,
    );

    const key = hasMultipleShipments
      ? ShipmentDisplay.MultiShipmentOrder
      : ShipmentDisplay.SingleShipmentOrder;

    return shipmentDisplayFactory(key);
  };

  return (
    <Container
      data-testid="tracking-details-header-container"
      alignment={(!isMobile && headerAlignment) || CONTENT_ALIGNMENT.CENTER}
    >
      <span>{getTitle()}</span>
    </Container>
  );
};
